export default {
  "content": "<path d=\"M18 16h3v2h-3v3h-2v-3h-3v-2h3v-3h2v3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 13a1 1 0 011 1v6a1 1 0 01-1 1H4a1.001 1.001 0 01-1-1v-6a1 1 0 011-1h6zm-5 6h4v-4H5v4zM10.102 3.005A1 1 0 0111 4v6a1 1 0 01-1 1H4a1.001 1.001 0 01-1-1V4a1 1 0 011-1h6l.103.005zM5 9h4V5H5v4zM20 3a1 1 0 011 1v6a1 1 0 01-1 1h-6.001A1 1 0 0113 10V4a1 1 0 011-1h6zm-5 6h4V5h-4v4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};